import CustomerOrderPage from '../pages-core/customer/CustomerOrderPage'
import CustomerOrderViewPage from '../pages-core/customer/CustomerOrderViewPage'
import CustomerOrderCreatedPage from '../pages-core/customer/CustomerOrderCreatedPage'
import BarOrderPage from '../pages-core/buisiness/BarOrderPage'
import BarOrderViewPage from '../pages-core/buisiness/BarOrderViewPage'
import OrderResetPage from "@/modules/delivery/pages-core/buisiness/OrderResetPage";


const routes = [
    {
        name: 'CustomerOrderPage',
        path: '/order',
        component: CustomerOrderPage,
        meta: {
            requiresAuth: false
        }
    },
    {
        name: 'CustomerOrderCreatedPage',
        path: '/order/created/:identifier',
        component: CustomerOrderCreatedPage,
        meta: {
            requiresAuth: false
        }
    },
    {
        name: 'CustomerOrderViewPage',
        path: '/order/view/:identifier',
        component: CustomerOrderViewPage,
        meta: {
            requiresAuth: false
        }
    },

    //BUSINESS
    {
        name: 'BarOrderPage',
        path: '/bar/order/create',
        component: BarOrderPage,
        meta: {
            requiresAuth: true,
            permission: "ORDER_CREATE"
        }
    },
    {
        name: 'BarOrderEditPage',
        path: '/bar/order/edit/:identifier',
        component: BarOrderPage,
        meta: {
            requiresAuth: true,
            permission: "ORDER_UPDATE"
        }
    },
    {
        name: 'BarOrderViewPage',
        path: '/bar/order/view/:identifier',
        component: BarOrderViewPage,
        meta: {
            requiresAuth: true,
            permission: "ORDER_UPDATE"
        }
    },
    {
        name: 'OrderResetPage',
        path: '/order/reset',
        component: OrderResetPage,
        meta: {
            requiresAuth: true,
            permission: "ORDER_UPDATE"
        }
    },

    //BUSINESS SALON
    {
        name: 'SalonOrderPage',
        path: '/salon/order/create',
        component: BarOrderPage,
        meta: {
            requiresAuth: true,
            permission: "ORDER_CREATE"
        }
    },
    {
        name: 'SalonOrderEditPage',
        path: '/salon/order/edit/:identifier',
        component: BarOrderPage,
        meta: {
            requiresAuth: true,
            permission: "ORDER_UPDATE"
        }
    },

    {
        name: 'SalonOrderViewPage',
        path: '/salon/order/view/:identifier',
        component: BarOrderViewPage,
        meta: {
            requiresAuth: true,
            permission: "ORDER_UPDATE"
        }
    }
]

export default routes;
